module.exports = __webpack_public_path__ + "bf5305c0ed62615ae8059a326594c430.svg";